import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { TransactionType, Quote } from '../../../models/common/trading-common.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { createQtyCalculatorForm } from '../../../utils';
import { Subscription } from 'rxjs';
import { TradingService } from '../../../services/common/trading-service.service';


@Component({
    selector: 'qty-calculator-component',
    templateUrl: './qty-calculator.component.html',
    styleUrls: ['./qty-calculator.component.css']
})

/**
 * The Quantity Calculator component to calculate the Trade Quantity from $ Amount to trade and $ Price of Security.
*/
export class QtyCalculatorComponent implements OnInit, OnDestroy {

    qtyCalculatorForm: FormGroup;

    MIN_VAL: number = 0.01;
    MAX_VAL: number = 999999999.99;
    transactionType: TransactionType;
    quotes: Quote;

    priceLabel: string = 'labels.calcUsing.askPrice';
    quantity: number = 0;
    principal: number = 0.0;
    disableApply: boolean = false;
    qtyCalculatorTransationStyle: string = 'tr-QtyCalculator_Quantity';
    activeTheme: string;
    amountSubscription: Subscription;
    priceSubscription: Subscription;

    constructor(private fb: FormBuilder, private tradingService: TradingService,public dialogRef: MatDialogRef<QtyCalculatorComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.transactionType = data.transactionType;
        this.quotes = data.quotes;
        console.log('Calculator Constructed!');        
    }
    

    ngOnInit() {
        this.activeTheme = this.tradingService.getActiveThemeFromCurrentContainer();
        this.qtyCalculatorForm = createQtyCalculatorForm(this.fb);

        if (this.transactionType === TransactionType.BUY || this.transactionType === TransactionType.BUY_TO_COVER) {
            this.priceLabel = 'labels.calcUsing.askPrice';
            this.price().setValue(this.quotes.sqtAskPrc);
            this.qtyCalculatorTransationStyle = 'tr-QtyCalculator_Buy';
        } else if (this.transactionType === TransactionType.SELL_FROM_PORTFOLIO || this.transactionType === TransactionType.SELL_NOT_IN_ACCOUNT ||
            this.transactionType === TransactionType.SHORT_SALE_EXEMPT || this.transactionType === TransactionType.SELL_SHORT) {
            this.priceLabel = 'labels.calcUsing.bidPrice';
            this.price().setValue(this.quotes.sqtBidPrc);
            this.qtyCalculatorTransationStyle = 'tr-QtyCalculator_Sell';
        }

        if (this.price().value === null || this.price().value === undefined || this.price().value <= 0.0) {
            this.priceLabel = 'labels.calcUsing.lastPrice';
            this.price().setValue(this.quotes.sqtLastPrc);
        }

        this.updateApplyState();

        this.amountSubscription = this.amount().valueChanges.subscribe((change: any) => this.onAmountChange(change));
        this.priceSubscription = this.price().valueChanges.subscribe((change: any) => this.onPriceChange(change));
    }

    isRetail(): boolean {
        return this.tradingService.tradingEntitlements.isRetailUser;

    }


    onAmountChange(changeVal) {
        if (this.amount().valid) {
            this.updateQty('AP');
        }
    }

    onPriceChange(changeVal) {
        if (this.price().valid) {
            this.updateQty('AP');
        }
    }

    updateQty(upDown: string) {
        if (upDown === 'up' && this.quantity < this.MAX_VAL) {
            this.quantity += 1;
        } else if (upDown === 'down' && this.quantity > this.MIN_VAL) {
            this.quantity -= 1;
        } else if (upDown === 'AP') {
            this.quantity = Math.floor(this.amount().value / this.price().value);
        }

        this.principal = this.quantity * this.price().value;
        this.updateApplyState();
    }

    updateApplyState() {
        this.disableApply = true;

        if (this.amount().value >= this.MIN_VAL && this.amount().value <= this.MAX_VAL && 
            this.price().value >= this.MIN_VAL && this.price().value <= this.MAX_VAL && this.quantity >= this.MIN_VAL) {
            this.disableApply = false;
        }
    }

    closeCalc(applyQty: boolean) {
        if (!!this.dialogRef) {
            this.dialogRef.close(applyQty ? this.quantity : null);
        }
    }

    amount(): AbstractControl {
        return this.qtyCalculatorForm.get('amount');
    }

    price(): AbstractControl {
        return this.qtyCalculatorForm.get('price');
    }

    ngOnDestroy() {
        if (!!this.amountSubscription) {
            this.amountSubscription.unsubscribe();
        }
        
        if (!!this.priceSubscription) {
            this.priceSubscription.unsubscribe();
        }

        console.log('Calculator destroyed!');
    }
}
